"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCategoryTreeDisplayName = void 0;
const enums_1 = require("../enums");
const isEmpty_1 = require("../helper/isEmpty");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCategoryTreeDisplayName(breadcrumbs, type) {
    const breadcrumbTitles = breadcrumbs.map(item => item.title);
    if (!type && (0, isEmpty_1.isEmpty)(breadcrumbs)) {
        return;
    }
    if (type === enums_1.PageType.PRODUCTS) {
        breadcrumbTitles.pop();
    }
    (0, pushToDataLayer_1.pushToDataLayer)({
        CategoryTreeDisplayName: breadcrumbTitles.join(' > '),
    });
}
exports.trackCategoryTreeDisplayName = trackCategoryTreeDisplayName;
//# sourceMappingURL=trackCategoryTreeDisplayName.js.map